import { render, staticRenderFns } from "./fixedRoute.vue?vue&type=template&id=0585964d"
import script from "./fixedRoute.vue?vue&type=script&lang=js"
export * from "./fixedRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports